import React from "react";
import { Link as ScrollLink } from "react-scroll";
import jez from "../assets/formal.jpg";
import { IoMdArrowDropright } from "react-icons/io";
import { motion } from "framer-motion";


function Home() {
  return (
    <div name="home" className="h-screen w-full bg-black text-white flex flex-col md:flex-row pb-10 md:pb-0 pt-20">

      
      {/* Left Section (Image) */}
      <div className="flex-1 flex items-center justify-center w-full h-3/4 md:h-full">
        <motion.img
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          transition={{ duration: 4 }}
          src={jez}
          alt="my profile"
          className="w-full h-full object-cover object-[0_20%]"
        /> 
      </div>

      {/* Right Section (Text and Button) */}
      <div className="flex-1 flex flex-col justify-center text-center md:text-left p-8 md:pl-8 md:h-full">
        
        {/* Animated Introduction */}
        <motion.h2 
          initial={{ opacity: 0, y: -50 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5 }}
          className="text-4xl md:text-5xl mb-4"
        >
          Hi! I'm Jez
        </motion.h2>

        {/* Animated Title */}
        <motion.h1 
          initial={{ x: 50, opacity: 0 }} 
          animate={{ x: 0, opacity: 1 }} 
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="text-3xl md:text-7xl text-beige mb-6"
        >
          Front-end Web Developer & eBay Specialist
        </motion.h1>

        {/* Contact Button */}
        <motion.div 
          initial={{ opacity: 0, y: 50 }} 
          animate={{ opacity: 1, y: 0 }} 
          transition={{ duration: 1.5, delay: 0.5 }}
          className="flex justify-center md:justify-start items-center"
        >
          <ScrollLink
            to="contact"
            smooth={true}
            duration={700}
            spy={true}
            offset={-70}
          >
            <button className="group bg-gray-800 text-white font-bold w-fit px-6 py-3 my-2 flex items-center rounded-md border border-white hover:bg-gray-600 transition duration-300">
              Contact
              <span className="group-hover:rotate-90 duration-300">
                <IoMdArrowDropright size={20} className="ml-3" />
              </span>
            </button>
          </ScrollLink>
        </motion.div>
      </div>
    </div>
  );
}

export default Home;
